export const routeName = 'legal-disclaimer';
/**
 * The slugs `www` already serves, plus French, which `www` does not publish but the redesign does.
 * Deliberately identical where the two sites overlap — the same reasoning as `about-us` and `contact`:
 * a visitor who lands on one host's legal notice and switches to the other should not change URL word.
 */
export const slugs: Record<string, string> = {
	es: 'aviso-legal',
	en: 'legal-disclaimer',
	ca: 'avis-legal',
	fr: 'mentions-legales',
	it: 'note-legali',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-09-02' };
